import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface NamespaceDataFieldInterface extends VarcharDatatypeInterface {
  data?: string;
}

export class NamespaceDataFieldClass extends String
  implements NamespaceDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
